import { Cart, CartItem, GiftCardCartItem } from '__generated__/graphql';
import { ActiveCart, ActiveCartItem } from 'types/cart';
import { buildProductUrl } from 'utils/buildProductUrl';

export type ItemMeta = {
  name: string;
  pdpUrl: string;
  outOfStock: boolean;
  imageUrl: string;
  adjustQuantityMessage?: string;
  stockMessageCode?: string;
};

const getMetaForProduct = (
  productCartItem: ActiveCartItem | CartItem,
  giftCardName: string,
  compact?: boolean
): ItemMeta => {
  if (productCartItem.__typename === 'ProductCartItem') {
    const { product } = productCartItem;
    const outOfStock =
      productCartItem.hasStock !== undefined &&
      productCartItem.hasStock !== null
        ? !productCartItem.hasStock
        : (product.inventory || 0) < productCartItem.quantity;
    const adjustQuantityMessage =
      productCartItem.adjustQuantityMessage || undefined;

    const pdpUrl = buildProductUrl(product.masterId, product.name, {
      color: product.colorValue,
      ...(product.size.value && { size: product.size.value }),
    });

    const imageUrl =
      !compact && productCartItem.personalizationImageURL
        ? productCartItem.personalizationImageURL
        : product.images[0].href;

    const stockMessageCode = productCartItem.stockMessageCode ?? undefined;

    return {
      adjustQuantityMessage,
      stockMessageCode,
      name: product.name,
      pdpUrl,
      outOfStock,
      imageUrl,
    };
  }

  return {
    adjustQuantityMessage: undefined,
    name: giftCardName,
    pdpUrl: '/pd/digital-gift-card/VirtualGiftCard',
    outOfStock: false,
    imageUrl: (productCartItem as GiftCardCartItem).imageUrl,
    stockMessageCode: undefined,
  };
};

export const useProductCartWarnings = (cart: ActiveCart | Cart) => {
  return cart?.products
    ? (cart?.products
        .map(product => {
          const _meta = getMetaForProduct(product, '');
          if (
            _meta.outOfStock ||
            (_meta.adjustQuantityMessage && _meta.stockMessageCode)
          ) {
            return _meta.adjustQuantityMessage;
          }
          return null;
        })
        .filter(item => item != null) as string[])
    : [];
};

export const useCartProductMeta = () => {
  return {
    getMetaForProduct,
  };
};
